import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Typography,
  Box,
  Tooltip,
  IconButton,
  InputBase,
  Button,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseDiscountCode } from "./UseDiscountCode";
import { UseMyPC } from "../../../hooks/UseMyPC";
import CustomPagination from "../../../components/CustomPagination";
import ProgressCom from "../../../components/ProgressCom";
import Detail from "../../../main/detail/Detail";
import { deCapitalizeFirstLetter } from "../../../util/Utils";
import DeleteRow from "../../../components/DeleteRow";
import { rsProgress, rsActiveMenu, rsGotoLast } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import SearchFilter from "./SearchFilter";
import { useNavigate, useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";

export default function DiscountCode() {
  const navigate = useNavigate();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getDiscountCode, deleteDiscountCode, UpdateDiscountCode } =
    UseDiscountCode();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("IsActive", "Desc");
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchcolumn, setSearchcolumn] = useState(undefined);
  const [codeRes, setCodeRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setSearchcolumn(undefined);
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getDiscountCode(myPc, search, searchcolumn, (Codes) => {
      setCodeRes(Codes);
    });
  }, [myPc, searchcolumn]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/discountmanagment/discountCode/addCode", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "discountCode",
      headerName: "کد تخفیف",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "logdate",
      headerName: "تاریخ ایجاد",
      width: 120,
      align: "center",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "shamsiLogdate",
      headerName: "تاریخ ایجاد",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "shamsiExpiredate",
      headerName: "تاریخ انقضا",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "isActive",
      headerName: "وضعیت",
      width: 95,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2">
            {cellValues.row.isActive ? "فعال" : "غیرفعال"}
          </Typography>
        );
      },
    },
    {
      field: "isPublic",
      headerName: "کاربر",
      width: 90,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2">
            {cellValues.row.isPublic ? "عمومی" : "سفارشی"}
          </Typography>
        );
      },
    },
    {
      field: "allOrder",
      headerName: "سفارش",
      width: 115,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2">
            {cellValues.row.allOrder ? "عمومی" : "سفارشی"}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.productName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());
                  return navigate("/discountmanagment/discountCode/editCode", {
                    state: {
                      // myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/discountmanagment",
        title: "محصولات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/discountmanagment",
          },
          {
            name: "کد تخفیف",
            url: "/discountmanagment/discountCode",
          },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          sx={{
            mb: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <SearchFilter
            setSearchState={setSearchState}
            search={search}
            setSearch={setSearch}
            searchcolumn={searchcolumn}
            setSearchcolumn={setSearchcolumn}
          />
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            onClick={() => {
              setProgress(true);
              UpdateDiscountCode();
            }}
          >
            به‌روز رسانی
          </Button>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          {codeRes ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={codeRes.pageCondition.pageCount}
              rows={codeRes.codes}
              paginationMode="server"
              page={codeRes.pageCondition.page - 1}
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={
                codeRes?.pageCondition.totalItemCount
                  ? codeRes.pageCondition.totalItemCount
                  : 1
              }
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  newFunc: newFunc,
                  scrollTo: myPc.scrollTo,
                  isLtr: true,
                  rowCount: codeRes?.pageCondition.totalItemCount
                    ? codeRes.pageCondition.totalItemCount
                    : "",
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: {
                  page: myPc.page,
                },
              }}
              sx={{
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "&  .MuiDataGrid-columnHeader:focus-within": {
                  outline: "none",
                },
                "&  .MuiDataGrid-cell:focus-within ": {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
                "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
                  {
                    outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                  },
                "& .MuiDataGrid-cell:hover": {
                  opacity: "80%",
                  // cursor: "pointer",
                },
                "& .MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !important",
                },
                "& .primary": {
                  width: "100%",
                  backgroundColor: "#e6d0ff !important",
                },
                "& .none": {
                  width: "100%",
                  backgroundColor: "#fff !important",
                },
                "& .Green": {
                  backgroundColor: "#56ff004f !important",
                },
                "& .red": {
                  backgroundColor: "#ff9c9c !important",
                },
              }}
              getRowClassName={(params) => {
                if (params.row.isActive) {
                  return "Green";
                } else {
                  return "red";
                }
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
      </Box>
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"کد تخفیف"}
        callback={() => {
          setProgress(true);
          deleteDiscountCode(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
